// extracted by mini-css-extract-plugin
export const section = "section-module--section--YznOK";
export const content = "section-module--content--2B9du";
export const yellow = "section-module--yellow--34DSj";
export const grey = "section-module--grey--AUwDu";
export const green = "section-module--green--383D6";
export const red = "section-module--red--yrfDT";
export const anchor = "section-module--anchor--ugefh";
export const fullbleed = "section-module--fullbleed--20gRR";